<template>
  <section class="custom-file-document">
    <div class="custom-file-host">
      <div
        v-if="canUpload"
        :ref="`fileDragDrop_${name}`"
        class="row custom-drag-drop"
        draggable="true"
        @dragover.prevent="onDrag"
        @dragleave="onDragLeave"
        @drop="handleDrop"
      >
        <div class="col">
          <input
            :ref="`fileUploader_${name}`"
            type="file"
            multiple
            :id="`file-uploader_${folder}`"
            class="custom-file-upload"
            @change="handleFileInput"
            accept=".pdf,.doc,.xls,.jpg,.jpeg,.png"
          />
          <label :for="`file-uploader_${folder}`" class="custom-drag-drop-label">
            <i class="fa-solid fa-upload"></i> Drag & Drop or <span class="custom-choose-file">Choose file</span> to upload
          </label>
        </div>
      </div>
      <div class="custom-file-list-wrapper">
        <div class="row custom-file-list">
          <div v-if="isLoading">
            <span>Loading...</span>
          </div>
        </div>
        <div v-if="!isLoading">
          <div class="custom-file-list" v-for="(file, index) in currentFiles" :key="index">
            <div class="row">
              <div class="col">
                <div class="input-group">
                  <span class="input-group-text">Name:</span>
                  <input type="text" class="form-control" v-model="file.altname" @change="changedName(file)" />
                </div>
                <div class="custom-file-link">
                  <a @click="showFile(file)">
                    {{ file.url }}
                  </a>
                </div>
              </div>
              <div class="col-1 text-center">
                <button class="custom-file-delete" tabindex="-1" @click="confirmDeleteFile(file.url)">
                  <i class="fa-solid fa-trash"></i>
                </button>
                <button class="custom-file-analyze" tabindex="-1" @click="analyzeFile(file.url)">
                  <i class="fa-solid fa-image"></i>
                  <span>analyze</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="noData === true && !isLoading" class="custom-file-list-none">
        <span>No Files Found</span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <Message v-model="message" class="alert alert-warning mt-2" />
      </div>
    </div>
  </section>
  <DialogPreview :show="actionPreview" modalSize="modal-xl">
    <template v-slot:header>
      <div class="row" style="width: 100%">
        <div class="col">
          <span class="custom-title">Preview</span>
          <span class="float-end" data-bs-dismiss="modal" @click="closeModal">
            <i class="fa fa-close" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </template>
    <template v-slot:body>
      <div v-if="isLoading">
        <span>loading...</span>
      </div>
      <div v-else-if="isError" class="custom-error">
        <div class="row">
          <div class="col">
            <span>{{ errorMessage }}</span>
          </div>
        </div>
        <div v-if="isAnyJson" class="row">
          <div class="col">
            <json-viewer v-show="isAnyJson" :value="jsondata" copyable />
          </div>
        </div>
      </div>
      <object v-else width="100%" :height="height" :data="previewContent" :type="mimeType"></object>
    </template>
    <template v-slot:footer>
      <button type="button" class="btn btn-primary px-4" data-bs-dismiss="modal" @click="closeModal">Okay</button>
    </template>
  </DialogPreview>
  <ConfirmDelete
    v-model="actionDelete"
    :confirm-title="confirmDeleteTitle"
    :confirm-action="confirmDeleteAction"
    :confirm-question="confirmDeleteQuestion"
    @closing="closeModal"
    @proceed="performFileDeletion"
  />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { fileStore } from '@/stores/file'
import axios from 'axios'
import DialogPreview from '@/components/utilities/elements/Dialog.vue'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
import Message from '@/components/utilities/elements/Message.vue'
import { JsonViewer } from 'vue3-json-viewer'
import 'vue3-json-viewer/dist/index.css'
const apiUrl = window.config ? window.config.apiUrl : ''
export default {
  name: 'FileUpload',
  components: {
    DialogPreview,
    ConfirmDelete,
    Message,
    JsonViewer
  },
  props: {
    name: String,
    firm: String,
    vin: String,
    refId: String,
    folder: String,
    type: String,
    isShowScans: {
      type: Boolean,
      default: false
    },
    nothingFound: String,
    isNameUpdate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      message: null,
      confirmDeleteTitle: 'File Deletion',
      confirmDeleteAction: 'Delete',
      confirmDeleteQuestion: 'Are you sure you wish to Permanently Delete this File?',

      saveFilesUrl: `${apiUrl}/data/uploadFiles`,
      fileToDelete: null,
      actionConfirm: null,
      actionPreview: null,
      previewContent: null,
      isLoading: false,
      mimeType: 'application/pdf',
      height: '100%',
      isError: false,
      errorMessage: null,
      jsondata: null,
      isAnyJson: false
    }
  },
  watch: {
    vin() {
      // console.log('VIN Changed', {
      //   vin: this.vin,
      //   id: this.refId
      // })
      // if (this.refId !== null && this.refId !== undefined) {
      //   this.getFiles({
      //     firm: this.firmId,
      //     folder: this.folder,
      //     vin: this.currentVin,
      //     id: this.refId
      //   })
      // }
    }
  },
  emits: ['file-uploaded'],
  computed: {
    ...mapState(authStore, ['token']),
    ...mapState(fileStore, ['files']),
    canUpload() {
      let _can = false
      if (this.firm !== null && this.vin !== null && this.refId !== null) {
        _can = true
      }
      return _can
    },
    currentFiles() {
      let _files = []
      if (this.files) {
        _files = this.files
      }
      console.log('Current Files', _files)
      return _files
    },
    noData() {
      let _is = false
      if (this.currentFiles.length === 0) {
        _is = true
      }
      return _is
    },
    currentVin() {
      return this.vin
    }
  },
  methods: {
    ...mapActions(fileStore, ['getFiles', 'deleteFile', 'getFile', 'updateFileInfo']),
    closeModal() {
      this.actionConfirm = null
      this.actionPreview = null
      this.message = null
      this.isError = false
      this.errorMessage = null
    },
    async handleFileInput() {
      this.isLoading = true
      const element = this.$refs[`fileUploader_${this.name}`]
      const file = element.files
      await this.saveFiles(file)
    },
    async handleDrop(event) {
      this.isLoading = true
      event.preventDefault()
      const element = this.$refs[`fileDragDrop_${this.name}`]
      if (element) {
        element.classList.remove('file-active-drag')
      }
      const selectedFile = event.dataTransfer.files
      await this.saveFiles(selectedFile)
    },
    onDrag(event) {
      event.preventDefault()
      const element = this.$refs[`fileDragDrop_${this.name}`]
      if (element) {
        element.classList.add('file-active-drag')
      }
    },
    onDragLeave(event) {
      event.preventDefault()
      const element = this.$refs[`fileDragDrop_${this.name}`]
      if (element) {
        element.classList.remove('file-active-drag')
      }
    },
    async changedName(record) {
      let file = this.currentFiles.find((x) => x.url === record.url)
      let data = {
        url: file.url,
        altname: file.altname
      }
      await this.updateFileInfo(data)
    },
    async saveFiles(files) {
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      for (let idx = 0; idx < files.length; idx++) {
        const file = files[idx]
        axios({
          method: 'post',
          url: this.saveFilesUrl,
          data: {
            files: file,
            folder: this.folder,
            firm: this.firm,
            vin: this.vin,
            id: this.refId,
            name: null
          },
          cancelToken: source.token,
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${this.token}`
          }
        })
          .then(() => {
            this.getFiles(this.firm).then(() => {
              this.isLoading = false
              this.$emit('file-uploaded', true)
            })
          })
          .catch((thrown) => {
            if (axios.isCancel(thrown)) {
              this.message = 'File is not uploaded, Please try again.'
              console.log('Request canceled', thrown.message)
            } else {
              this.message = 'File is not uploaded, Please try again.'
              console.log(thrown)
            }
          })
      }
    },
    async showFile(file) {
      try {
        this.isLoading = true
        this.isError = false
        this.errorMessage = null
        this.jsondata = null
        this.previewContent = null
        this.actionPreview = false
        console.log('File', file)
        if (file.url.indexOf('.blob.') > 0) {
          console.log('PDF File', file.name.indexOf('.pdf'))
          if (file.name.toUpperCase().indexOf('.PDF') > 0) {
            this.actionPreview = true
            try {
              if (file.name.toUpperCase().indexOf('.PDF') > 0) {
                this.mimeType = 'application/pdf'
              }
              this.height = '650px'
              const response = await fetch(file.url)
              if (!response.ok) {
                this.errorMessage = `Failed to fetch PDF: ${response.statusText}`
              }
              const blob = await response.blob()
              const fixedBlob = new Blob([blob], { type: this.mimeType })
              // Create a local URL for the blob
              this.previewContent = URL.createObjectURL(fixedBlob)
            } catch (error) {
              this.isError = true
              this.errorMessage = error.message || 'An error occurred while loading the PDF.'
            } finally {
              this.isLoading = false
            }
          } else {
            window.open(file.url, '_blank')
          }
          this.isLoading = false
        }
      } catch (error) {
        console.error('Error:', error)
        this.isLoading = false
      }
    },
    base64ToBlob(base64) {
      const binaryString = atob(base64)
      const arrayBuffer = new ArrayBuffer(binaryString.length)
      const uint8Array = new Uint8Array(arrayBuffer)

      for (let i = 0; i < binaryString.length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i)
      }
      return new Blob([uint8Array], { type: this.mimeType })
    },
    confirmDeleteFile(filename) {
      this.fileToDelete = filename
      this.actionConfirm = true
      console.log('confirm file to delete', this.fileToDelete)
    },
    async performFileDeletion(filename) {
      console.log('perform file to delete', filename)
      this.isLoading = true
      this.actionConfirm = null
      let data = {
        folder: this.folder,
        filename: filename,
        id: this.refId
      }
      await this.deleteFile(data)
      await this.getFiles(this.firm).then(() => {
        this.isLoading = false
      })
    },
    cleanFilename(data) {
      console.log('Cleaning Filename', data)
      const matches = data.match(/\d\/(.+)$/)
      if (matches && matches.length > 1) {
        return matches[1]
      } else {
        return null
      }
    },
    updateFileName(filename) {
      let data = {
        filename: filename,
        name: null,
        opportunity: this.refId
      }
      console.log('Updating File Name', data)
    },
    analyzeFile(url) {
      this.$emit('analyze-file', url)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-file-document {
  min-height: 250px;
  height: 100%;
}
.custom-file-host {
  border: 1px solid #e8eaf1;
  border-radius: 5px;
  overflow: hidden;
  padding: 10px;
  margin: 10px;
}
.custom-title {
  font-size: 1.2em;
  font-weight: 500;
}
.file-active-drag {
  background-color: #abcfa3;
}
.custom-drag-drop {
  border: 2px dashed;
  border-color: #e8eaf1;
  border-radius: 6px;
  background-color: #ddfce7;
  font-size: 1em;
  padding: 10px;
  margin-top: 5px;
  margin-left: 10px;
  width: 98%;
  margin-bottom: 10px;
  text-align: center;
}
.custom-choose-file {
  color: #0eba45;
}
.custom-choose-file:hover {
  cursor: pointer;
}
.custom-file-list-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 300px;
  margin-top: 15px;
}
.custom-drag-drop-label {
  font-size: 0.9em;
  font-weight: 500;
  margin-left: 5px;
}
.custom-file-upload {
  width: 0;
  opacity: 0;
  overflow: hidden;
}
.custom-file-list {
  border-radius: 6px;
  width: 100%;
  height: 100%;
}
.custom-file-link {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9em;
  min-height: 45px;
  a {
    padding: 10px;
  }
}
.custom-file-delete {
  position: relative;
  border: 1px solid #e8eaf1;
  color: rgb(133, 0, 0);
  border-radius: 5px;
  top: 0;
  right: 2px;
  font-size: 0.9em;
}
.custom-file-list-none {
  text-align: center;
  max-height: 150px;
  height: 100%;
  font-style: italic;
}
.custom-preview {
  min-height: 550px;
  height: 550px;
}
.custom-error {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 450px;
}
.custom-file-analyze {
  position: relative;
  border: 1px solid #e8eaf1;
  color: rgb(25, 61, 177);
  border-radius: 5px;
  top: 12px;
  right: 3px;
  font-size: 0.8em;
}
</style>
